export const Lake = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M2 21a4.25 4.25 0 014 0 4.25 4.25 0 004 0 4.25 4.25 0 014 0 4.25 4.25 0 004 0 4.25 4.25 0 014 0M2 14h20M5 8v6M2 17.5a4.25 4.25 0 014 0 4.25 4.25 0 004 0 4.25 4.25 0 014 0 4.25 4.25 0 004 0 4.25 4.25 0 014 0M16 11l-2.1-2.8a.5.5 0 00-.8 0L11 11M22 11l-2.146-3.52a1 1 0 00-1.708 0L16 11'
        ></path>
        <ellipse cx='5' cy='7' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' rx='3' ry='4'></ellipse>
      </svg>
    </span>
  );
};
